import React, { useState } from "react";
import axios from "axios";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) return;
    setLoading(true);
    try {
      await axios.post("/api/auth/forgot-password", { email });
      setStatus("success");
    } catch {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0a0e1a",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          background: "rgba(0,245,255,0.03)",
          border: "1px solid rgba(0,245,255,0.15)",
          borderRadius: 12,
          padding: 40,
          width: "100%",
          maxWidth: 400,
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div
            style={{
              color: "#00f5ff",
              fontSize: 28,
              fontWeight: 700,
              letterSpacing: 2,
            }}
          >
            RIGIQ
          </div>
          <div style={{ color: "#888", fontSize: 13, marginTop: 4 }}>
            RESET YOUR PASSWORD
          </div>
        </div>

        {status === "success" ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ color: "#00f5ff", fontSize: 40, marginBottom: 16 }}>
              ✓
            </div>
            <p style={{ color: "#ccc", marginBottom: 8 }}>Reset link sent!</p>
            <p style={{ color: "#888", fontSize: 13 }}>
              Check your email for a link to reset your password. It expires in
              1 hour.
            </p>
            <a
              href="/"
              style={{
                display: "block",
                marginTop: 24,
                color: "#00f5ff",
                fontSize: 13,
              }}
            >
              ← Back to login
            </a>
          </div>
        ) : (
          <>
            <p style={{ color: "#aaa", fontSize: 14, marginBottom: 24 }}>
              Enter your email address and we'll send you a link to reset your
              password.
            </p>

            {status === "error" && (
              <div
                style={{
                  background: "rgba(255,80,80,0.1)",
                  border: "1px solid rgba(255,80,80,0.3)",
                  borderRadius: 6,
                  padding: "10px 14px",
                  marginBottom: 16,
                  color: "#ff5050",
                  fontSize: 13,
                }}
              >
                Failed to send reset email. Please try again.
              </div>
            )}

            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  color: "#888",
                  fontSize: 11,
                  letterSpacing: 1,
                  display: "block",
                  marginBottom: 6,
                }}
              >
                EMAIL ADDRESS
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                placeholder="you@company.com"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  background: "rgba(0,245,255,0.05)",
                  border: "1px solid rgba(0,245,255,0.2)",
                  borderRadius: 6,
                  color: "#fff",
                  fontSize: 14,
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading || !email}
              style={{
                width: "100%",
                padding: "13px",
                background: loading ? "rgba(0,245,255,0.3)" : "#00f5ff",
                color: "#0a0e1a",
                border: "none",
                borderRadius: 6,
                fontWeight: 700,
                fontSize: 14,
                letterSpacing: 1,
                cursor: loading ? "not-allowed" : "pointer",
                marginBottom: 16,
              }}
            >
              {loading ? "SENDING..." : "SEND RESET LINK →"}
            </button>

            <a
              href="/"
              style={{
                display: "block",
                textAlign: "center",
                color: "#888",
                fontSize: 13,
                textDecoration: "none",
              }}
            >
              ← Back to login
            </a>
          </>
        )}
      </div>
    </div>
  );
}
